export { BffBrandType } from '@src/lib/__generated/beffe/sdk';
export type { BffFacility } from '@src/lib/__generated/beffe/sdk';

export enum FacilityBrand {
	AspenDental = 'ASPEN_DENTAL',
	Chapter = 'CHAPTER',
	ClearChoice = 'CLEAR_CHOICE',
	Lovet = 'LOVET',
	WellNow = 'WELL_NOW',
	Motto = 'MOTTO',
}

// the following enums are used for testing
export enum FacilityServiceBrand {
	AspenDental = 'ASPEN_DENTAL',
	Invisalign = 'INVISALIGN',
	Motto = 'MOTTO',
}

export enum FacilityServiceType {
	ClearAligners = 'CLEAR_ALIGNERS',
	Implants = 'IMPLANTS',
	SpanishSpeaking = 'SPANISH_SPEAKING',
}
